/**
 * Node Modules
 */
import React from 'react'
import { Link } from 'gatsby'

/**
 * Application Modules
 */
import './style.css'
import '../../../components/styles/buttons.css'
import Section from '../../../components/section'
import Header from '../../../components/header'
import Spacer from '../../../components/spacer'

/**
 * Component
 */
export default function Hero({ hed, dek, styles }) {
  return (
    <Section
      className="life-at-kinzoo-hero"
      styles={
        styles || {
          '--logo-color': 'var(--white)',
          '--color': 'var(--white)',
          '--active-color': 'var(--coral)',
          '--background-color': 'var(--light-purple)',
        }
      }
    >
      <Header
        styles={
          styles || {
            '--logo-color': 'var(--white)',
            '--color': 'var(--white)',
            '--active-color': 'var(--coral)',
            '--background-color': 'var(--light-purple)',
          }
        }
      />
      <div className="life-at-kinzoo-hero__container flex flex-center">
        <div className="life-at-kinzoo-hero__grid grid">
          <div className="column-start-1 column-end-6 column-start-2--t column-end-11--t  column-start-3--d column-end-10--d">
            <Spacer size={[50, 100]} />
            <h1 className="life-at-kinzoo-hero__hed column-start-1 column-end-6 column-start-2--t column-end-11--t column-start-3--d column-end-10--d">
              {hed}
            </h1>
            <Spacer size={[10, 40]} />
            <p className="life-at-kinzoo-hero__dek column-start-1 column-end-6 column-start-2--t column-end-11--t column-start-3--d column-end-10--d">
              {dek}
            </p>
            <Spacer size={[40, 65]} />
          </div>
        </div>
      </div>
    </Section>
  )
}
